import { Components, Theme } from "@mui/material";

export const MuiAccordionSummary: Components<Theme>["MuiAccordionSummary"] = {
  styleOverrides: {
    root: {
      borderRadius: 5,
      minHeight: 60,
      "&.Mui-expanded": {
        borderRadius: 0,
      },
    },
    content: {
      margin: 0,
    },
  },
};
